/**
 * Answer of `GET /v1/me/capabilities` — what the signed-in caller may do, so the UI can
 * render accordingly instead of offering an action the server will refuse.
 *
 * `allowedLanguages` is never empty: where no restriction is configured the server
 * answers with the full supported set, which is what the write accepts in that state.
 */
export interface MeCapabilities {
  allowedLanguages: string[];
  /**
   * Roleplay modes the caller may start a session in. Optional because a Core that
   * predates the entitlement omits it, and a required field would have the next
   * consumer read it straight off a payload that has none.
   */
  allowedModes?: string[];
  canCreatePersona: boolean;
  canCreateScenario: boolean;
}

/**
 * Keyed by caller, and deliberately NOT under the users collection root: this answers
 * "what may the signed-in caller do", which no admin mutation on that collection can
 * change, and the caller in the key keeps one account's answer from serving another.
 */
export const ME_CAPABILITIES_QUERY_KEY = (userPublicId: string | null) =>
  ['core', 'me', 'capabilities', userPublicId ?? ''] as const;
